__webpack_require__.p = "/fortune-india/assets/";